<template>
    <v-row class="hide-overflow flex-nowrap h-100" no-gutters>
        <v-col class="hide-overflow">
            <v-row class="pt-4 pb-3 pl-4 pr-4 b-b mb-0" dense>
                <v-col>
                    <v-select label="Status" :items="statuses" v-model="filters.status" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }" :loading="loading"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Area" :items="areas" v-model="filters.area" outlined multiple clearable hide-details dense
                    :menu-props="{ offsetY: true }" :loading="loading"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Category" :items="categories" v-model="filters.category" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }" :loading="loading"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Source" :items="sources" v-model="filters.source" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }" :loading="loading"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Reason to hide" :items="reasonsToHide" v-model="filters.reasonToHide" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }" :loading="loading"></v-select>
                </v-col>
                <v-col>
                    <v-text-field
                    label="Free-text search"
                    outlined
                    dense
                    v-model="filters.searchString"
                    placeholder="Title or company name"
                    clearable
                    hide-details
                    ></v-text-field>
                </v-col>
                <!-- <v-col>
                    TODO: NOT IMPLEMENTED
                    <v-btn outlined block color="primary" elevation="0" @click="importDialog = true">
                        Import jobs
                    </v-btn>
                </v-col> -->
                <v-col>
                <PositionNew @jobCreated="getJobs()" />
                </v-col>
            </v-row>
            <v-row class="hide-overflow flex-nowrap" style="height:88%;" dense no-gutters>
                <v-col :cols="showEditor ? 8 : 12">
                    <div class="list-view">
                        <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items.sync="items"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            @page-count="pageCount = $event"
                            class="elevation-1"
                            hide-default-footer
                            @click:row="selectRow"
                            item-key="key"
                        >
                            <template v-slot:[`item.schedule.publish`]="{ item }">
                                <span v-if="item.schedule && item.schedule.publish">
                                    {{ displayDate(item.schedule.publish) }}
                                </span>
                                <span v-else class="text--disabled">—</span>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn icon :href="item.externalUrl" target="_blank">
                                    <v-icon color="primary" small>mdi-open-in-new</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:[`item.seniority`]="{ item }">
                                <span v-if="item.clustering && item.clustering.seniority && item.clustering.seniority.id">
                                    {{ getSeniorityName(item.clustering.seniority.id) }}
                                </span>
                                <span v-else class="text--disabled"></span>
                            </template>
                            <template v-slot:[`item.parsedStatus`]="{ item }">
                                <span v-for="status of Object.entries(item.parsedStatus).filter(e => e[1]).map(e => e[0]) "
                                    :key="status">
                                    <v-chip
                                        label
                                        small
                                        outlined
                                        class="mr-1"
                                        :color="getStatusColor(status)"
                                        v-if="status !== 'reviewed'">
                                        {{ status }}
                                    </v-chip>
                                </span>
                            </template>
                        </v-data-table>
                        <v-row class="pagination align-center">
                        <v-col class="ml-2">
                            <strong>Page {{ page }}</strong> of {{ pageCount }}
                        </v-col>
                        <v-col>
                            <v-pagination
                                v-model="page"
                                :length="pageCount"
                                total-visible="8">
                            </v-pagination>
                        </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col class="b-l auto-overflow" v-if="showEditor">
                    <JobEditor :item="selectedJob" :action="editorAction" @saved="getJobs()" @close="showEditor = false" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import JobEditor from '@/components/JobEditor.vue';
import PositionNew from '@/components/PositionNew.vue';

const UNCATEGORIZED_CATEGORY_ID = 'uncategorized';
const UNCATEGORIZED_CATEGORY_NAME = 'Uncategorized';

export default {
  name: 'PositionListAdmin',
  components: {
    JobEditor,
    PositionNew,
  },
  data() {
    return {
      headers: [
        { text: 'Publish', value: 'schedule.publish' },
        { text: 'Company', value: 'employer.name' },
        { text: 'Job title', value: 'title' },
        { text: 'Seniority', value: 'seniority' },
        { text: 'City', value: 'location.city' },
        { text: 'Area', value: 'location.area' },
        { text: 'Status', value: 'parsedStatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      statuses: [
        { text: 'Reviewed', value: 'reviewed' },
        { text: 'Unreviewed', value: 'unreviewed' },
        { text: 'Hidden', value: 'hidden' },
        { text: 'User submitted', value: 'userSubmitted' },
        { text: 'Reported', value: 'reported' },
        { text: 'Active', value: 'active' },
        { text: 'Expired', value: 'expired' },
      ],
      sources: [
        { text: 'Työmarkkinatori', value: 'tyomarkkinatori' },
        { text: 'Jobly', value: 'monster' },
        { text: 'The Hub', value: 'thehub' },
        { text: 'Academic Positions', value: 'academicpositions' },
        { text: 'Aalto University', value: 'aalto' },
        { text: 'Microsoft', value: 'microsoft' },
        { text: 'Teamtailor', value: 'teamtailor' },
        { text: 'Manually added', value: 'test-api' },
      ],
      startDateModal: false,
      endDateModal: false,
      filters: {
        status: [],
        area: [],
        category: [],
        source: [],
        reasonToHide: [],
        searchString: '',
      },
      itemsPerPage: 8,
      page: 1,
      pageCount: 0,
      selectedJob: {},
      showEditor: false,
      editorAction: 'create',
      loading: false,
    };
  },
  async mounted() {
    await this.$store.dispatch('dispatchReasonsToHideAdmin');
    await this.$store.dispatch('dispatchSeniorityLevels');
    await this.$store.dispatch('dispatchCategoriesWithDetails');
    this.fetchJobsIfAuthenticated();
  },
  methods: {
    displayDate(isoString) {
      if (!isoString) return '';
      const d = new Date(isoString);
      return new Intl.DateTimeFormat(undefined, { dateStyle: 'short' }).format(d);
    },
    selectRow(item) {
      this.showEditor = true;
      this.selectedJob = item;
      this.$store.dispatch('commitSelectedPosition', item);
    },
    getJobs() {
      this.loading = true;
      this.$store.dispatch('dispatchGetJobsAdmin')
        .finally(() => {
          this.loading = false;
        });
    },
    fetchJobsIfAuthenticated() {
      if (this.isAuthenticated) {
        this.getJobs();
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'reviewed':
          return 'blue';
        case 'unreviewed':
          return 'orange';
        case 'hidden':
          return 'default';
        case 'userSubmitted':
          return 'info';
        case 'reported':
          return 'error';
        case 'active':
          return 'success';
        case 'expired':
          return 'error';
        default:
          return 'grey';
      }
    },
    getSeniorityName(seniorityId) {
      const seniorityLevel = this.$store.state.seniorityLevels
        ? this.$store.state.seniorityLevels.find(level => level.id === seniorityId)
        : null;
      return seniorityLevel ? seniorityLevel.name : '';
    },
  },
  computed: {
    items() {
      let items = this.$store.state.searchResults || [];
      items = items.sort((a, b) => new Date(b.source.firstSeen).getTime() - new Date(a.source.firstSeen).getTime());
      items = items.map((item, i) => {
        const parsedStatus = {
          reviewed: item.status.reviewStatus !== 'unreviewed',
          unreviewed: item.status.reviewStatus === 'unreviewed',
          hidden: Object.keys(item.status.hiddenBecause).length > 0,
          userSubmitted: item.source.apiId.includes('jobsinfinland.fi'),
          reported: Object.keys(item.status.reportedBecause).length > 0,
          active:
            Object.keys(item.status.hiddenBecause).length === 0
            && new Date(item.schedule.expire).getTime() > Date.now(),
          expired: new Date(item.schedule.expire).getTime() < Date.now(),
        };
        const newItem = { ...item, parsedStatus, key: i };
        return newItem;
      }).filter((item) => {
        const itemFilterStates = [
          (this.filters.status && this.filters.status.length > 0)
            ? this.filters.status.some(status => item.parsedStatus[status]) : true,
          (this.filters.area && this.filters.area.length > 0)
            ? this.filters.area.includes(item.location.area) : true,
          (this.filters.category && this.filters.category.length > 0)
            ? (() => {
                const isUncategorizedOptionSelected = this.filters.category.includes(UNCATEGORIZED_CATEGORY_ID);
                const selectedCategories = this.filters.category.filter(c => c !== UNCATEGORIZED_CATEGORY_ID);

                const jobCategories = (item.clustering && item.clustering.categories) || [];
                const isJobUncategorized = !jobCategories || jobCategories.length === 0;

                if (isUncategorizedOptionSelected && selectedCategories.length > 0) {
                  return isJobUncategorized || jobCategories.some(c => selectedCategories.includes(c.id));
                }
                if (isUncategorizedOptionSelected && selectedCategories.length === 0) {
                  return isJobUncategorized;
                }
                return jobCategories.some(c => selectedCategories.includes(c.id));
              })() : true,
          (this.filters.source && this.filters.source.length > 0)
            ? this.filters.source.some(s => item.source.apiId.includes(s)) : true,
          (this.filters.reasonToHide && this.filters.reasonToHide.length > 0)
            ? this.filters.reasonToHide.some(r => Object.keys(item.status.hiddenBecause).includes(r)) : true,
          (this.filters.searchString && this.filters.searchString.length > 0)
            ? item.title.toLowerCase().includes(this.filters.searchString.toLowerCase())
            || item.employer.name.toLowerCase().includes(this.filters.searchString.toLowerCase()) : true,
        ];
        return itemFilterStates.every(f => f);
      });
      return items;
    },
    areas() {
      let areas = (this.$store.state.mapData || []).map((area) => {
        return { text: area.name, value: area.name };
      });
      areas.push({ text: 'Unknown', value: 'Unknown' });
      return areas;
    },
    categories() {
      return [
        { text: UNCATEGORIZED_CATEGORY_NAME, value: UNCATEGORIZED_CATEGORY_ID },
        ...((this.$store.state.categoriesWithDetails || []).map((category) => {
          return { text: category.name, value: category.id };
        })),
      ];
    },
    reasonsToHide() {
      return this.$store.state.reasonsToHideAdmin ? this.$store.state.reasonsToHideAdmin.map((reason) => {
        return { text: reason.description, value: reason.id };
      }).filter((reason) => {
        return reason.value !== 'deleted';
      }) : [];
    },
    seniorityLevels() {
      return this.$store.state.seniorityLevels ? this.$store.state.seniorityLevels.map((level) => {
        return { text: level.name, value: level.id };
      }) : [];
    },
    isAuthenticated() {
      return this.$store.state ? this.$store.state.JWT !== null : false;
    },
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.getJobs();
      }
    },
  },
};
</script>
<style>

</style>